import React from 'react'

import { getSurveyLabel } from '../utils'

import { useVisibleSurveys } from './useVisibleSurveys'

export const useCategories = () => {
  const surveys = useVisibleSurveys()

  return React.useMemo(() => surveys.map(getSurveyLabel), [surveys])
}
